import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import Reveal from '../components/Reveal';

/**
 * Fehlerseite für unbekannte Adressen.
 * Den HTTP-Status 404 setzt der Server (spa.php), diese Seite ist die
 * sichtbare Entsprechung dazu.
 */
export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navigation />

      <section className="flex-1 pt-40 pb-28">
        <div className="container-custom max-w-3xl">
          <Reveal>
            <span className="kicker mb-6 inline-flex">Fehler 404</span>
          </Reveal>
          <Reveal delay={0.1}>
            <h1 className="font-display text-6xl md:text-8xl text-foreground leading-[0.9] mb-6">
              Seite nicht
              <span className="block text-brand">gefunden.</span>
            </h1>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="text-lg text-foreground/80 mb-10 max-w-xl leading-relaxed">
              Diese Adresse gibt es nicht oder sie wurde verschoben.
              Von hier kommst du zurück zu unseren Arbeiten.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <div className="flex flex-wrap gap-4">
              <Link to="/" className="btn-primary">Zur Startseite</Link>
              <Link to="/portfolio" className="btn-outline">Portfolio ansehen</Link>
            </div>
          </Reveal>
        </div>
      </section>

      <Footer />
    </div>
  );
}
